import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s7_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "form-field-floating reactive active my-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "form-field-floating reactive my-4" }
const _hoisted_7 = {
  key: 1,
  class: "text-red"
}
const _hoisted_8 = { class: "s13_mobile px-4" }
const _hoisted_9 = { class: "widget px-8 pt-7 pb-9" }
const _hoisted_10 = { class: "font-semibold mb-5" }
const _hoisted_11 = { class: "grid4 grid-row-gap-1" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "card-check-text" }
const _hoisted_14 = ["id", "onUpdate:modelValue"]
const _hoisted_15 = {
  key: 0,
  class: "text-red"
}
const _hoisted_16 = { class: "flex gap-2" }

import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RolesFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const permissions = ref([] as any[]);
    const formData = reactive({
        id: "",
        libelle: "",
        description: "",
        codes_permissions: {} as any
    });
    const errors = reactive({
        libelle: "",
        description: ""
    });

    onMounted(() => {
        const form_params: any = route.meta.form_params;
        permissions.value = form_params.permissions;
        if (form_params.role) {
            const role = form_params.role as any;
            formData.id = role.id;
            formData.libelle = role.libelle;
            formData.description = role.description;
            formData.codes_permissions = {};
            role.codes_permissions.forEach((c: any) => {
                formData.codes_permissions[c] = true;
            });
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="Le libellé est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                libelle: formData.libelle,
                description: formData.description,
                codes_permissions: Object.keys(formData.codes_permissions).filter((c: any) => formData.codes_permissions[c] === true)
            };
            await axios.post(`/backoffice/roles/save`, formToUpload);
            router.push('/app/roles/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Rôles / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.libelle) = $event)),
            name: "libelle",
            id: "libelle",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.libelle]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "libelle" }, [
            _createTextVNode("Rôle "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['libelle'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors['libelle']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("textarea", {
            class: "form-input lg",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.description) = $event)),
            name: "description",
            id: "description",
            rows: "3"
          }, null, 512), [
            [_vModelText, formData.description]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "description" }, "Description", -1))
        ]),
        (!!errors['description'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errors['description']), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-semibold mb-0" }, "Permisions", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (permission, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: 'permission_' + index
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "mt-7 mb-5" }, null, -1)),
            _createElementVNode("h5", _hoisted_10, _toDisplayString(permission.label), 1),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.permissions, (childPermission, childIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card-check color single mb-0",
                  key: 'child_permission_' + childIndex
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: 'cpermission_' + index + '_' + childIndex
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-check-icon" }, [
                      _createElementVNode("img", { src: "/icons/icon-securite-permission.svg" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        name: "permissions[]",
                        id: 'cpermission_' + index + '_' + childIndex,
                        "onUpdate:modelValue": ($event: any) => ((formData.codes_permissions[childPermission.id]) = $event)
                      }, null, 8, _hoisted_14), [
                        [_vModelCheckbox, formData.codes_permissions[childPermission.id]]
                      ]),
                      _createElementVNode("h6", null, _toDisplayString(childPermission.label), 1)
                    ])
                  ], 8, _hoisted_12)
                ]))
              }), 128))
            ])
          ], 64))
        }), 128)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg',
            loading: loading.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"]),
          _cache[9] || (_cache[9] = _createElementVNode("button", { class: "btn stroke black lg" }, [
            _createElementVNode("span", null, "Effacer")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})